import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { AppDownloadAnchorLink } from 'app/marketing/components/AppDownloadAnchorLink'
import { HomeHeroImage } from './HomeHeroImage'
import underline from 'assets/images/text/text-underline-blue.svg'

export const HomeHero = () => {
  const { colors, mediaQueries, presetStyles } = useTheme()

  const buttonAnchor = {
    id: 'app-download',
    offset: 160,
    className: css`
      display: inline-flex;
      ${mediaQueries.mobileL} {
        width: auto;
      }
    `,
  }

  return (
    <FlexBox
      data-testid="homeHero"
      className={cx(
        css`
          margin-bottom: 24px;
          padding: 160px 24px 0;
          background-color: ${colors.uiPearlExtraLight};
          overflow: hidden;
          ${mediaQueries.tabletL} {
            padding-top: 60px;
            min-height: 606px;
          }
        `,
        'fade'
      )}
      centerAll
    >
      <FlexBox
        className={css`
          align-items: center;
          flex-direction: column;
          max-width: 1080px;
          width: 100%;
          ${mediaQueries.tabletL} {
            justify-content: center;
            flex-direction: row;
            gap: 32px;
          }
        `}
      >
        <FlexBox
          className={css`
            text-align: center;
            flex-direction: column;
            align-items: center;
            max-width: 290px;
            ${mediaQueries.mobileL} {
              max-width: 340px;
              flex-shrink: 0;
            }
          `}
        >
          <Text
            type="header"
            color={colors.uiGraphite}
            custom={{
              fontSize: '48px',
              lineHeight: '42px',
              letterSpacing: '-2px',
              [mediaQueries.mobileL]: {
                fontSize: '72px',
                lineHeight: '66px',
                letterSpacing: '-4px',
              },
              [mediaQueries.tabletL]: {
                fontSize: '80px',
                lineHeight: '72px',
              },
            }}
          >
            Find your
            <br />
            Book Club
          </Text>
          <Text
            className={css`
              position: relative;
              margin-top: -21px;
              ${presetStyles.textOutline({
                width: 1,
                color: colors.uiPearlExtraLight,
              })}
              ${mediaQueries.mobileL} {
                margin-top: -28px;
                ${presetStyles.textOutline({
                  width: 2,
                  color: colors.uiPearlExtraLight,
                })}
              }
              ${mediaQueries.tabletL} {
                margin-top: -30px;
              }
            `}
            type="script"
            color={colors.uiBlue}
            custom={{
              fontSize: '45px',
              lineHeight: 'normal',
              letterSpacing: '-2px',
              [mediaQueries.mobileL]: {
                fontSize: '60px',
              },
              [mediaQueries.tabletL]: {
                fontSize: '72px',
              },
            }}
          >
            Community
            <img
              className={css`
                margin-top: -10px;
                display: block;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 96px;
                ${mediaQueries.mobileL} {
                  margin-top: -14px;
                  width: 120px;
                }
                ${mediaQueries.tabletL} {
                  width: 147px;
                }
              `}
              src={underline}
              alt="comunity text underline"
            />
          </Text>
          <Text
            className={css`
              margin: 16px 0;
            `}
            type="body"
            sizing="M"
            color={colors.uiGraphite}
          >
            Hop into one of our thousands of book clubs moderated by everyone
            from authors to BookTokers to LeVar Burton.
          </Text>
          <AppDownloadAnchorLink anchor={buttonAnchor} />
        </FlexBox>
        <HomeHeroImage />
      </FlexBox>
    </FlexBox>
  )
}
